<template>
	<div id="page-content" class="supplier-sidebar">

		<div style="padding: 20px 50px;">

			<!-- START: if there are no items in cart -->
			<div v-if="!show" class="text-center">
				<h1>You currently have no items in cart</h1>
				<router-link to="/products" style="
					display: inline-block;
					font-size: 1.17em;
					border: 1px solid transparent;
					background: #4DCC2F;
					padding: 0.75em 1em;
					border-radius: 1.5em;
					color: #fff;
				">Start Shopping!</router-link>
			</div>
			<!-- END: if there are no items in cart -->

			<h1 v-if="show" style="display: inline-block;">My Cart</h1>

			<div v-if="show" style="display: block; overflow: hidden; margin: 10px 0;">
				<div class="col-md-2"></div>
				<div class="col-md-3">Product Name</div>
				<div class="col-md-2 text-center">Quantity</div>
				<div class="col-md-3 text-right">Price</div>
				<div class="col-md-2 text-right">Options</div>
			</div>

			<!-- item emit -->
			<item 
				v-if="show" 
				v-for="item in items" 
				:item="item"
				@increment="incrementTotal($event)"
				@decrement="decrementTotal($event)"
				@additem="additem($event)"
				@removeitem="removeitem($event)"
				:key="item.code"
				>
			</item>
			<!-- item emit -->

			<div v-if="show" style="margin-top: 40px" class="text-center">
				<strong>Total Items</strong> {{ total }} 
				<strong>Total Price</strong> Php {{ formatMoney(price) }} 
				<!-- <strong>Bug fixed. Reset quantity on route change</strong> -->
			</div>
			
			<div v-if="show" class="pull-right" style="padding: 0px 15px; margin-top: 40px;">
				<button class="button-type-e" @click="placeOrder">Place Order</button>
			</div>

			<transition name="fade">
				<notification v-if="notification" @endtransaction="endtransaction"></notification>
			</transition>

			<transition name="fade">
				<notification-b v-if="notificationb" :nbc="nbc" :nbm="nbm"></notification-b>
			</transition>

			<!-- a membership notification -->
			<transition name="fade">
				<notification-s v-if="notificationS"></notification-s>
			</transition>

		</div>
	</div>
</template>

<script>
	import OrderNotification from './OrderNotification.vue';
	//this is notification b
	import CartNotification from './CartNotification.vue';
	//notificationS
	import MembershipNotification from './MembershipNotification.vue';
	import Item from './Item.vue';
	export default{
		props: ['items', 'issessionset'],
		data(){
			return{
				token: '',
				total: 0,
				price: 0,
				itemsinfo: [],
				show: false,
				notification: false,
				notificationb: false,
				//this is experimental
				nbc: '#EBD911',
				nbm: 'Item Removed',
				//this is experimental

				notificationS: false
				//don't turn off the trigger 
				//force user to create an account;
				//so that we can keep track of their purchases
			}
		},
		methods: {

			formatMoney: formatMoney,

			gettoken: function(){
				//this is experimental 

				//do not try this at home
			},

			endtransaction: function(){
				this.notification = false;
				this.$emit('endtransaction');
			},

			additem: function(iteminfo){
				this.itemsinfo.push(iteminfo);
				this.total++;
				this.price += parseFloat(iteminfo.price);
			},

			incrementTotal: function(iteminfo){
				this.total++;
				this.price += parseFloat(iteminfo.price);
				for(var i = 0; i < this.itemsinfo.length; i++){
					if(this.itemsinfo[i].code === iteminfo.code){
						this.itemsinfo[i].quantity = iteminfo.quantity;
						this.itemsinfo[i].total = iteminfo.total;
						break;
					}
				}
			},
			decrementTotal: function(iteminfo){
				this.total--;
				this.price -= parseFloat(iteminfo.price);
				for(var i = 0; i < this.itemsinfo.length; i++){
					if(this.itemsinfo[i].code === iteminfo.code){
						this.itemsinfo[i].quantity = iteminfo.quantity;
						this.itemsinfo[i].total = iteminfo.total;
						break;
					}
				}
			},
			removeitem: function(iteminfo){
				var self = this;
				for(var i = 0; i < this.itemsinfo.length; i++){
					if(this.itemsinfo[i].code === iteminfo.code){
						this.total -= iteminfo.quantity;
						this.price -= iteminfo.total;
						this.itemsinfo.splice(i, 1);
						this.$emit('removeitem', iteminfo.code);
						break;
					}
				}
				this.notificationb = true;
				setTimeout(function(){
					self.notificationb = false;
				}, 3000);
			},
			placeOrder: function(){
				var self = this;

				var ordersinfo = [];
				ordersinfo.push(this.itemsinfo.length, this.price); // 2, 500,000

				
				$.ajax({
					url: 'static/php/orders.php',
					type: 'post',
					data: {
						ordersinfo: ordersinfo, 
						itemsinfo: self.itemsinfo,
						token: self.token
					},
					success: function(data){
						//data = string '1'
						if(data == true){

							self.notification = true;
							
						}else if(data === 'session'){

							//alert('You need to be logged in or registered to continue with your purchase');
							self.notificationS = true;

						}else if(data === 'token'){
							//fix this later 
							$.ajax({
								url: 'static/php/gettoken.php',
								success: function(data){
									if(typeof data === "string"){
										self.token = data;
									}
								}
							});

							//fix this later
							//use csrf on when posting data RULE 34

							alert('token mismatch');
						}else{
							$.ajax({
								url: 'static/php/gettoken.php',
								success: function(data){
									if(typeof data === "string"){
										self.token = data;
									}
								}
							});							

							alert('Oops something went wrong. try refreshing your browser');
						}
					}
				});
				
			}
			
		},
		created(){
			//this is the cart right?
			//users must have session to access this.
			var self = this;
				//temporary move the code;
				//display items?
				if(this.items.constructor === Array){
					if(this.items.length < 1){
						this.show = false;
					}else{
						this.show = true;
					}
				}
				//display items?
			if(this.issessionset === true){
				//temporary move the code;
				//assumption issessionset is true on create
				$.ajax({
					url: 'static/php/gettoken.php',
					success: function(data){
						if(typeof data === "string"){
							self.token = data;
						}
					}
				});
				//assumption issessionset is true on create
			}else{
				//this.$router.push({path: '/login'});
			}
			
		},	
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch:{
			issessionset: function(newval){
				if(newval !== true){
					//this.$router.push({path: '/login'});
				}
			},
			items: function(newval){
				if(this.items.length < 1){
					this.show = false;
				}else{
					this.show = true;
				}
			}
		},
		components: {
			'item': Item,
			'notification': OrderNotification,
			'notification-b': CartNotification,
			'notification-s': MembershipNotification
		}
	}
</script>


// WEBPACK FOOTER //
// Cart.vue?0a7da908